export interface GalleryImage {
  id: number;
  url: string;
  alt: string;
}

export const galleryData: GalleryImage[] = [
  { id: 1, url: '/images/galeri1.jpg', alt: 'Cigani Restaurant Sığacık - Ege mezeleriyle donatılmış meyhane masası' },
  { id: 2, url: '/images/galeri2.jpg', alt: 'Sığacık Cigani Restaurant - Akşam yemeği atmosferi ve meyhane dekoru' },
  { id: 3, url: '/images/galeri4.jpg', alt: 'Cigani Restaurant galeri - Modern Ege mutfağı sunumları' },
  { id: 4, url: '/images/galeri5.jpg', alt: 'Sığacık meyhane - Cigani Restaurant iç mekan tasarımı' },
  { id: 5, url: '/images/galeri6.jpg', alt: 'Cigani Restaurant - Ege mezeleri eşliğinde akşam yemeği' },
  { id: 8, url: '/images/galeri9.jpg', alt: 'Sığacık akşam yemeği - Cigani Restaurant meyhane deneyimi' },
  { id: 9, url: '/images/galeri10.jpg', alt: 'Cigani Restaurant - Ege mutfağı ve modern meyhane konsepti' },
  { id: 10, url: '/images/galeri11.jpg', alt: 'Sığacık Cigani Restaurant - Akşam yemeği ve meyhane atmosferi' },
  { id: 11, url: '/images/galeri12.jpg', alt: 'Cigani Restaurant galeri - Ege mezeleri ve zarif sunumlar' },
  { id: 12, url: '/images/galeri13.jpg', alt: 'Sığacık meyhane - Cigani Restaurant iç mekan ve dekor' },
  { id: 13, url: '/images/galeri14.jpg', alt: 'Cigani Restaurant - Modern Ege mutfağı ve meyhane deneyimi' },
  { id: 14, url: '/images/galeri15.jpg', alt: 'Sığacık Cigani - Akşam yemeği ve samimi meyhane atmosferi' },
  { id: 15, url: '/images/galeri16.jpg', alt: 'Cigani Restaurant - Ege mezeleri ve zarif sunumlar' },
  { id: 19, url: '/images/avlu2.jpg', alt: 'Cigani Restaurant Sığacık - Dış mekan avlu ve açık hava yemek alanı' },
  { id: 20, url: '/images/avlu21.jpg', alt: 'Sığacık Cigani - Avlu atmosferi ve dış mekan meyhane deneyimi' },
  { id: 21, url: '/images/koridor1.JPG', alt: 'Cigani Restaurant - İç mekan koridor ve modern meyhane tasarımı' },
]; 